export default "__VITE_ASSET__C$89SoLF__"